/**
 * Device Breakpoints
 * @description Breakpoints for responsive design
 * @enum {string}
 * @readonly
 * @property {string} MOBILE - Mobile breakpoint
 * @property {string} TABLET - Tablet breakpoint
 * @property {string} DESKTOP - Desktop breakpoint
 * @property {string} LARGE_DESKTOP - Large desktop breakpoint
 */
export var DeviceBreakpointsType;
(function (DeviceBreakpointsType) {
    DeviceBreakpointsType["MOBILE"] = "MOBILE";
    DeviceBreakpointsType["TABLET"] = "TABLET";
    DeviceBreakpointsType["DESKTOP"] = "DESKTOP";
    DeviceBreakpointsType["LARGE_DESKTOP"] = "LARGE_DESKTOP";
})(DeviceBreakpointsType || (DeviceBreakpointsType = {}));
//# sourceMappingURL=breakpoints.js.map